export default {
    openedPaneIds: true,
    currentPrimaryPaneOptionComponentId: true,
    paneOptionsComponents: true,
};